<template>
  <div class="button">
    <div class="number">{{ number }}</div>
    <div class="button__image">
      <img
        ontouchstart
        class="button__image--top"
        src="@/assets/practices/pet_life/button_green_top.svg"
        alt="button_green"
        @click="clickButton"
      />
      <img
        class="button__image--bottom"
        src="@/assets/practices/pet_life/button_green_bottom.svg"
        alt="button_green_bottom"
      />
    </div>
  </div>
</template>

<script>
// import { Howl } from 'howler';
import { mapGetters } from 'vuex';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'Button',
  props: {
    answer: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    number: Number,
  },
  computed: {
    ...mapGetters({
      answerStatus: 'petLife/answerStatus',
      gameCompleted: 'petLife/gameCompleted',
    }),
  },
  methods: {
    clickButton() {
      sounds.globalButton.play();
      if (this.answerStatus) {
        console.log('Button is already active.');
      } else if (this.gameCompleted) {
        console.log('Game is over. Click the Retry button to start over.');
      } else {
        this.$emit('clicked', this.answer);
        this.$store.state.petLife.answerStatus = true;
        console.log(`answerStatus is now ${this.answerStatus}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.button {
  @include flex-center;
  font-family: 'Minecrafter', sans-serif;

  .number {
    font-size: 6vh;
  }

  &__image {
    @include flex-center;
    position: absolute;
    transform: translate(0, 9vh);

    &--top {
      height: 8.5vh;
      position: absolute;
      z-index: 1;

      &:active {
        transform: translate(0, 10%);
      }
    }

    &--bottom {
      height: 8.5vh;
      position: absolute;
      transform: translate(0, 25%);
    }
  }
}
</style>
